<template>
    <div>
        <nav-breadcrumb :menu="[{label: '法务大数据查询'}]"/>
        <el-tabs v-model="activeName">
            <el-tab-pane label="个人" name="person"></el-tab-pane>
            <el-tab-pane label="企业" name="enterprise"></el-tab-pane>
        </el-tabs>
        <faihai-query-person v-if="activeName==='person'"></faihai-query-person>
        <faihai-query-enterprise v-else></faihai-query-enterprise>
    </div>
</template>

<script>
import FaihaiQueryPerson from "./FaihaiQueryPerson";
import xhr from "../../utils/xhr";
import FaihaiQueryEnterprise from "./FaihaiQueryEnterprise";
export default {
    name: "FaihaiQuery",
    components: {FaihaiQueryEnterprise, FaihaiQueryPerson},
    data(){
        return {
            activeName: 'person'
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FaihaiQuery.vue